<template lang="pug">
    div(class="_formo")
        slot
</template>

<script>
    /**
     * A subgroup within an `ib-form`. Subgroups are represented in a form's value as a nested
     * object.
     */
    export default {
        name: 'ib-form-object',

        props: {
            /**
             * Name of group; this is used as a property name during `ib-form` submission.
             */
            name: String,
            /**
             * Object containing names/values to populate the form.
             */
            value: Object
        },

        data() {
            return {
                isForm: true,
                valid: true,
                dispatching: false,
                control: [],

                /**
                 * Computed object containing value of all form entries. We do not make this
                 * reactive, because we do not want to recompute every time someone presses a key
                 * in one field when there are many.
                 */
                get ivalue() {
                    return this.control.reduce((ivalue, control) => {
                        if (control.name != null && !control.disabled) {
                            ivalue[control.name] = control.ivalue;
                        }
                        return ivalue;
                    }, {});
                }
            };
        },

        watch: {
            dispatching(to) {
                const control = this.control;
                for (let i = 0; i < control.length; i++) {
                    control[i].dispatching = to;
                }
            }
        },

        mounted() {
            let cmp = this;
            while ((cmp = cmp.$parent)) {
                if (cmp.isForm) {
                    this.form = cmp;
                    this.form._add(this);
                    break;
                }
            }
        },

        beforeDestroy() {
            if (this.form) {
                this.form._remove(this);
            }
        },

        methods: {
            /**
             * Test validity of all form controls; returns `true` if valid, `false` otherwise.
             * If invalid, focus the first invalid control.
             */
            validate() {
                let invalid;
                this.control.forEach(control => {
                    control.showvalid = true;
                    if (!control.validate() && !invalid) {
                        invalid = control;
                    }
                });
                if (invalid) {
                    invalid.focus();
                }
                return (this.valid = !invalid);
            },

            /**
             * Restore state of all controls to `value`, which may differ from displayed value in
             * computed forms. Reset validity state.
             */
            reset() {
                this.control.forEach(control => {
                    control.reset();
                });
            },

            focus() {
            },

            /** @private */
            _add(control) {
                if (!this.control.includes(control)) {
                    this.control.push(control);
                }
            },

            /** @private */
            _remove(control) {
                this.control = this.control.filter(c => c !== control);
            }
        }
    }
</script>
